module.exports = __webpack_public_path__ + "media/images/front/top/icon_chinese-medicine-5a317a89d0c7ae51241af82eff3ddb6b.png";